<template>
  <div class="sales-layout">
    <page-header>
      <template #custom-header>
        <step-title
          :title="$route.meta.title || ''"
          :description="$route.meta.description || ''"
        />
      </template>
    </page-header>

    <page-container>
      <router-view />
    </page-container>
  </div>
</template>

<script>
export default {};
</script>
